export enum ProductSelectType {
  vehicleSupport = 1, // 车辆支持页
  selfInspectManual, // 自检手册
  selfRepair, //自助维修
  instructions,
  policyDetail
}

export enum VehicleType {
  Balanced_P1 = 'P1',
  Karting_I2 = 'I2',
  Skate_H1 = 'H1',
  EBike_E2 = 'E2',
  EBike_E4 = 'E4'
}

export enum FeedBackType {
  FeedBackSelfRepair = 1, // 自助维修
  FeedBackSelfInspectManual, //自检手册
  FeedBackSupport // 车辆支持
}

export enum helpful {
  helpful = 1,
  unhelpful = 2
}
export enum OpenType {
  backHome = 0, // 返回首页
  link = 1, // 外链
  selfInspectManual = 2, // 自检手册
  instructions = 3, // 说明书
  policyDetail = 4, // 服务政策
  selfRepair = 5, // 自维修
  onlineRepair = 6, // 在线报修
  innerUrl = 7 // 内部链接
}

export enum BusinessType {
  selfRepair = 11, // 自助维修
  instruction = 4, // 产品资料
  policyDetail = 5, // 服务政策
  onlineRepair = 6, // 在线报修
  FAQ = 21, // 常见问题
  serviceSupport = 83, // 产品服务支持
  teachingVideos = 31 // 教学视频
}

export enum FeedBackBusinessType {
  searchFeedBack = 20, // 搜索反馈
  translateFeedBack = 22  // 翻译反馈
}